import { baseApi } from './base-api'


export const siteApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllSites: build.query<any, any>({
      query: () => ({
        url: `sites/getallsites`,
      })
    }),
    getAllTeams: build.query<any, any>({
      query: () => ({
        url: `sites/getallteams`,
      })
    }),
   
  })
})

export const {
  useGetAllSitesQuery,
  useGetAllTeamsQuery,
} = siteApi;